<template>
  <b-container fluid>
    <b-row>
      <b-col class="text-center">
        <h1 style="margin-top:25px;">Frequently Asked Questions</h1>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <ul>
          <li>
            <span class="font-weight-bold">How long does it take to process an application?</span><br/>
            The processing time is thirty (30) business days once all required information is received.
          </li>
          <li>
            <span class="font-weight-bold">Can I email my documents to the Minnesota Registry?</span><br/>
            No, all documents (in PDF format) must be uploaded into the new Nurse Aide Registry system.
          </li>
          <li>
            <span class="font-weight-bold">What do I need to do if my certificate has already expired?</span><br/>
            Make sure you have an account on the Nurse Aide Registry system. You must apply for a renewal with the required documents. You can email health.fpc-nar@state.mn.us or call the main office line at (651) 201-4200 to speak with a Credentialing representative if you have any questions.
          </li>
          <li>
            <span class="font-weight-bold">Do I need to complete a training program before I can take the knowledge test and skills test?</span><br/>
            No, any person can attempt to take the knowledge and the skills test without taking a training program.
          </li>
          <li>
            <span class="font-weight-bold">Is there a walk-up window or walk-in hours?</span><br/>
            No, the Minnesota registry does not have a walk-up window or walk-in hours.
          </li>
          <li>
            <span class="font-weight-bold">Can I use clinic employment to renew my Minnesota registry status?</span><br/>
            No, clinic employment cannot be used to renew your Minnesota registry status. Other unacceptable employment types include outpatient surgical centers, ambulatory surgical centers, urgency centers, urgent care, dental clinics, work as a phlebotomist, EMT, or work paid through a Fiscal Intermediary.
          </li>
          <li>
            <span class="font-weight-bold">Can I use a volunteer position to renew my Minnesota registry status?</span><br/>
            No, you must show paid employment of at least 8 regular hours to renew your Minnesota registry status.
          </li>
          <li>
            <span class="font-weight-bold">Can I use employment as an independent contractor to renew my Minnesota registry status?</span><br/>
            No.
          </li>
          <li>
            <span class="font-weight-bold">Is the Nurse Aide Registry system used for reporting Minnesota employment?</span><br/>
            Yes, but nurse aides endorsing from another state will select the Interstate Endorsement option when creating an account.
          </li>
          <li>
            <span class="font-weight-bold">What documents need to be attached to my renewal application?</span><br/>
            A paystub showing at least 8 hours of regular pay for employment performed on or before your expiration date.
          </li>
          <li>
            <span class="font-weight-bold">Can I update personal data in the Nurse Aide Registry system?</span><br/>
            Yes, you can update your personal data. The necessary legal documents must be included with requests for name changes and Social Security Number corrections. After reviewing the uploaded documents, a Credentialer will process the request. Any rejections will be communicated back to you.
          </li>

          <li>
            <span class="font-weight-bold">Do I need attach a job description?</span><br/>
            If your employment is not in a nursing home, certified boarding care home, assisted living, Medicare certified home health agency or hospice, you will need to attach a copy of your job description from the facility where you worked.
          </li>
          <li>
            <span class="font-weight-bold">Can I use private duty employment to renew my registry status?</span><br/>
            No, but there are certain instances where private duty employment would be acceptable.
          </li>
          <li>
            <span class="font-weight-bold">How will I be notified if my application is not accepted?</span><br/>
            You will receive a message via text or email using the notification option you selected when you registered. You need to log into your account and review the message sent.
          </li>
          <li>
            <span class="font-weight-bold">How do I know if my registry status has been renewed?</span><br/>
            Once your application is processed, you will receive a message by text or email using the notification option you selected when you registered. Your certificate is printable through the Nurse Aide Registry system.
          </li>
          <li>
            <span class="font-weight-bold">How do I know if you have received my email?</span><br/>
            You will receive a courtesy response verifying receipt of your email.
          </li>
          <li>
            <span class="font-weight-bold">How do I get my endorsement or verification form completed?</span><br/>
            MDH no longer processes endorsement or verification forms for other state nurse aide registries or licensing boards. Please direct the requester to the new system (a primary source verification) to complete the form. If there are additional items listed on the form that are not available on the system, you may email the verification form to MDH to complete. The form must be a PDF, allow MDH to sign digitally, and provide an email address where the form should be emailed to. Once completed, MDH will email the completed form to the state nurse aide registry or licensing board and carbon copy the nurse aide.
          </li>
          <li>
            <span class="font-weight-bold">How will Nursing Homes and Certified Boarding Care Homes complete the semi-annuals for staff reporting with the Nurse Aide Registry system?</span><br/>
            Nursing Home and Certified Boarding Care Home facilities will be able to create an account and update their nurse aides in real time. Administrators can add additional users to the registry system and manage the staff reporting dashboard.
          </li>
          <li>
            <span class="font-weight-bold">How will Facilities/Agencies (other than Nursing Homes and Certified Boarding Care Homes) report their nurse aides’ employment to the system?</span><br/>
            Previously, providers such as assisted living facilities, Medicare certified home health agencies and hospices would email or mail their nurse aides’ employment along with required documents to the Nurse Aide Registry program. In order to be placed on the registry, facilities must inform their nurse aides about the Nurse Aide Registry system. The nurse aide will need to create an account and submit the required documents. The request will be processed by a Credentialer, who will notify the nurse aide of any rejections or missing items.
          </li>
          <li>
            <span class="font-weight-bold">What employment of nurse aides should Facilities/Agencies report?</span><br/>
            Facilities can extend the expiration date of a nurse aide's certificate based on Last Worked Date. Please note that only nurse aides who meet the requirements under <a href="https://www.ecfr.gov/current/title-42/part-483/section-483.156" target="_blank">42 CFR 483.156(c) (opens in new tab)</a> and <a href="https:///www.ecfr.gov/current/title-42/part-483/section-483.35" target="_blank">42 CFR 483.35 (d) (opens in new tab)</a> can renew their certificate. Non-relating nursing services do not meet the requirement to renew.
          </li>
          <li>
            <span class="font-weight-bold">For Facilities: Who should create and register an account within the Nurse Aide Registry system?</span><br/>
            At this time only nursing home and certified boarding care home facilities can create and register an account. The Administrator or Authorized Agent (AA) listed on file with MDH Federal Licensing, Certification and Registration (LCR) section will need to create and register the account. From there, the Administrator/AA can add up to three (3) additional users to help manage the staff report.
          </li>
          <li>
            <span class="font-weight-bold">For Facilities: Which email will receive the Registration key?</span><br/>
            MDH will send the Registration key to the email on file for that facility. Please note, we cannot change or update the email. If there is a change in the Administrator/AA, have the new person must contact the Federal LCR team at <a href="mailto:health.hrd-fedlcr@state.mn.us">health.hrd-fedlcr@state.mn.us</a> to request the email be updated/changed.  The email in the NAR system will automatically be updated once the Federal LCR team approves the change.  At that point the new Administrator/AA can request to resend the Registration key.
          </li>
        </ul>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="mt-3">
          <router-link :to="{name: 'home'}">
            <b-button id="btnHome" variant="primary">Return Home</b-button>
          </router-link>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

export default {
  name: 'pay-stubs',

  created() {
     document.title = "Providing Pay Stubs FAQ - NAR"
  }
}
</script>

<style>
 li{
   margin-top:1rem;
 }
</style>